import React from 'react';
import { useTranslation } from 'react-i18next';
import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import { DataImport } from 'graphql-common';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
import { getDataImportKindOption } from '@lib/utils/dataImport';

type Props = {
  data: DataImport;
};

export default function DataImportKindChip(props: Props) {
  const { t } = useTranslation();
  const { data } = props;
  const { kind } = data;
  let label: string | undefined = '-';
  let leftIcon: string | undefined = '-';
  if (kind) {
    const option = getDataImportKindOption(kind);
    const labelKey = option?.labelKey;
    leftIcon = option?.leftIcon;
    label = labelKey ? t(labelKey) : undefined;
  }
  if (label === undefined) label = _upperFirst(_toLower(_startCase(kind)));

  return (
    <Chip
      type={ChipTypes.chipBlack}
      label={label}
      leftIcon={leftIcon}
      leftIconSymbolsOutlined
    />
  );
}
